import { initialState } from "../initialState";
import { SET_SESSIONS_DATA } from "../actions";

export default function setSessionsData(
  state = initialState.sessionsData,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case SET_SESSIONS_DATA:
      return payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/sessionsData.js